import { combineReducers } from 'redux'
import jobsReducer from 'store/reducers/jobs'
import profileReducer from 'store/reducers/profile'

export default combineReducers({ 
    jobs: jobsReducer,
    profile: profileReducer 
})